import { useQuery } from '@tanstack/react-query';

import { companyConfigurationService, CompanyConfiguration } from '@aslanpay/portal-common-lib';

const useFetchCompanyConfiguration = (id?: string) => {
  return useQuery<CompanyConfiguration, Error>(
    ['fetchCompanyConfiguration', id],
    () => companyConfigurationService.fetchCompanyConfiguration(id || ''),
    {
      enabled: !!id,
    }
  );
};

export default useFetchCompanyConfiguration;
